import { memo } from "react";
import TextInputPermitPDF from "../../inputs/TextInputPermitPDF";
import { formattedDateTimeWithoutSec } from "../../../lib/functions";
import AreaAccessPermitPDF from "../../inputs/AreaAccessPermitPDF";

interface PermitDetailsProps {
    permitDetails: {
        s_WorkCategory_En: string;
        s_WorkType_En: string;
        s_HighRiskWorkCategory_En: string;
        dt_PermitStartDate: any;
        dt_PermitEndDate: any;
        s_AffectedService_En: string;
        s_FloorNo: string;
        s_OfficeNo: string;

        buildings: {
            s_LocationName_En: string;
            s_LocationName_Ar: string;
            items: {
                s_BuildingName_En: string;
                s_BuildingName_Ar: string;
            }[];
        }[];
    };
}

const PermitDetails = ({
    permitDetails,
}: PermitDetailsProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-b border-black py-0.5">
                <span className="text-[10px] font-bold text-white">
                    Section 1: Permit Details
                </span>
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Affected Service:"
                    value={permitDetails?.s_AffectedService_En || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label=""
                    value=""
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Permit Start Date:"
                    value={(formattedDateTimeWithoutSec(permitDetails?.dt_PermitStartDate) || "")}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Permit End Date:"
                    value={(formattedDateTimeWithoutSec(permitDetails?.dt_PermitEndDate) || "")}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Work Category:"
                    value={permitDetails?.s_WorkCategory_En || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="High Risk Work"
                    value={permitDetails?.s_HighRiskWorkCategory_En || "-"}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Work Type:"
                    value={permitDetails?.s_WorkType_En || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label=""
                    value=""
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Floor No:"
                    value={permitDetails?.s_FloorNo || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Office No:"
                    value={permitDetails?.s_OfficeNo || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <AreaAccessPermitPDF buildings={permitDetails?.buildings} />
        </div>
    );
};

export default memo(PermitDetails);
